import {
  Container,
  CssBaseline,
  Box,
  Stack,
  Paper,
  Typography,
  Button,
} from '@mui/material'
import { BASE_URL } from '../../server/config/constants'

export function NoSubscription() {
  const handleSubscribe = () => {
    window.open(`${BASE_URL}/abone-ol`, '_blank')
  }

  return (
    <Box>
      <CssBaseline />
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Stack spacing={3} alignItems="center">
            <Typography variant="h5" component="h1" gutterBottom align="center">
              Abonelik Gerekli
            </Typography>

            <Typography
              variant="body1"
              align="center"
              color="text.secondary"
              sx={{ mb: 2 }}
            >
              Bu uygulamayı kullanabilmek için aktif bir aboneliğiniz olması
              gerekmektedir.
            </Typography>

            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={handleSubscribe}
              sx={{ minHeight: 48, fontSize: '1rem', mt: 2 }}
            >
              Abone Ol
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}
